import { render, staticRenderFns } from "./list-overview.vue?vue&type=template&id=d6d36e7a"
import script from "./list-overview.vue?vue&type=script&lang=js"
export * from "./list-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports